//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import ContainerRowReduxReadonlyTextAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField'
import * as actions from '../../redux/nemesis/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const refreshTotalAmount=(props:InvoiceHeaderForm$Props)=>{
    const { nemesis,isOverrideTotal } = props;
    
    if (!isOverrideTotal){
        let total = (nemesis.totalSumOfItemAmount:any);
        if (total){
            total = parseFloat(total)
            const changeFieldValue = (props.changeFieldValue:any)
            changeFieldValue('total',total.toFixed(2))
        }
    }
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const nemesis:ReducerState$Type = (props.nemesis:any)
    
    if (isInvalidDoc && Object.keys(nemesis.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        const arr:Array<mixed> = (nemesis.lineItems:any)
        if (arr.length > 0 && Object.keys(nemesis.formError).length == 0) {
            return (
                <div>
                    <button type="button" onClick={()=> submitOpenActionDialog()} 
                    className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                </div>    
            )
        }
    }
}

const autoCompleteDataSourceConfig = {
    text: "customer_name",
    value: "customer_name"
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, nemesis } = this.props
        if (!nemesis.customersLoaded){
            const populateCustomersList=(this.props.populateCustomersList:any)
            populateCustomersList(jwt);
        }
    }
    
    componentDidUpdate(){
        refreshTotalAmount(this.props)
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,nemesis,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,isOverrideCustomerName,isOverrideTotal} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
       
        if (nemesis.invoiceSubmitted) {
            return <Redirect to='/projectNemesis/submittedForm' />;
        }

        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={'customerName'} 
                    autoCompleteDatasourceConfig={autoCompleteDataSourceConfig}
                    label={'Customer Name'}
                    datas={nemesis.customers}
                    checkboxField={'isOverrideCustomerName'}
                    checkboxLabel={'Override this Customer Name field'}
                    isOverride={isOverrideCustomerName}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />
                <ContainerRowReduxTextField field={'poNo'} label={'PO Number'} />
                <ContainerRowReduxTextField field={'poDate'} label={'PO Date'} />
                <ContainerRowReduxTextField field={'serviceAddr'} textType={'number'} label={'Service Address'} />
                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'total'} textLabel={'Total'} textType={'number'}
                    checkboxField={'isOverrideTotal'} checkboxLabel={'Override this Total field'}
                    isOverride={isOverrideTotal} notOverrideFunc={refreshTotalAmount} 
                    parentProps={this.props}
                />
                <ContainerRowError errorMsg={nemesis.error} />
            
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideCustomerName: selector(state, 'isOverrideCustomerName'),
        isOverrideTotal: selector(state, 'isOverrideTotal'),
        total: selector(state, 'total')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.nemesis, jwt, taskAcceptedInfoId))  
      },
      populateCustomersList: (jwt:string)=>{
        dispatch(actions.populateCustomersList(jwt))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectNemesis/InvoiceHeaderForm.js